<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

    <div class="sidebar-header relative px-3 pt-3 pb-2 justify-content-start mb-4 mt-2">
        <div class="flex align-items-center gap-2 text-color">
            <div class="relative" [ngClass]="isSidebarOpen() ? 'w-3rem h-3rem' : 'w-3rem h-3rem'">
                <!-- imagem -->
                <img *ngIf="!showAvatarSkeleton" [src]="userPhoto" (load)="onAvatarLoad()"
                    (error)="onAvatarError($event)" [alt]="user_name || 'Perfil'" class="shadow-1 w-full h-full"
                    style="border-radius:12% !important; object-fit: cover;" />

                <!-- skeleton só durante o erro/carregamento do fallback -->
                <p-skeleton *ngIf="showAvatarSkeleton" width="100%" height="100%"></p-skeleton>
            </div>

            <div *ngIf="isSidebarOpen()" class="flex flex-column overflow-hidden">
                <span class="font-semibold text-lg white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ user_name || 'Usuário' }}
                </span>

                <!-- <button (click)="goProfile()"
                    class="p-button p-button-text p-0 text-sm text-color-secondary no-underline white-space-nowrap shadow-none">
                    ver perfil
                </button> -->
                <button (click)="goProfile()"
                    class="p-button p-button-text p-0 text-small text-color-secondary no-underline white-space-nowrap shadow-none">
                    ver perfil </button>
            </div>
        </div>

        <button *ngIf="!isMobile() && layoutService.state.sidebarActive"
            class="layout-sidebar-anchor p-link border-circle w-1-5rem h-1-5rem inline-flex align-items-center justify-content-center absolute top-50 right-1"
            type="button" (click)="anchor()">
            <i class="pi pi-pin text-xs"></i>
        </button>
    </div>

    <div class="sidebar-header px-3 pb-4 pt-0">
        <!-- <button pButton pRipple icon="pi pi-plus-circle" class="btn-adicionar w-full p-button-label"
            (click)="goToLives()">
            <ng-container *ngIf="layoutService.state.sidebarActive || isMobile()">
                <div class="ml-2 ss-l-btn-plus">add slick</div>
            </ng-container>
        </button> -->
        <button pButton pRipple (click)="goToLives()"
            class="p-element p-ripple btn-adicionar p-button-label p-button p-component p-button-icon-only w-full">
            <i class="p-button-icon bi bi-magic" aria-hidden="true" style="font-size: 1.2rem;"></i>
            <ng-container *ngIf="layoutService.state.sidebarActive || isMobile()">
                <div _ngcontent-ng-c606226538="" class="ml-2 ss-l-btn-plus ng-star-inserted">Adicionar Slick</div>
            </ng-container>
            <!----><!---->
            <span _ngcontent-ng-c606226538="" class="p-ink"></span>
        </button>
    </div>


    <!-- novo mini banner -->
    <!-- ### DIV do botão "Adicionar Slick" -->
    <!-- <button _ngcontent-ng-c606226538="" pbutton="" pripple="" icon="pi pi-plus-circle" class="p-element p-ripple btn-adicionar p-button-label p-button p-component p-button-icon-only w-full">
        <i class="p-button-icon bi bi-magic" aria-hidden="true" style="font-size: 1.2rem;"></i>
        <div _ngcontent-ng-c606226538="" class="ml-2 ss-l-btn-plus ng-star-inserted">Adicionar Slick</div>
        <span _ngcontent-ng-c606226538="" class="p-ink"></span>
    </button> -->

    <!-- ### Botão de "ver perfil" -->
    <!-- <button _ngcontent-ng-c606226538="" class="p-button p-button-text p-0 text-small text-color-secondary no-underline white-space-nowrap shadow-none"> ver perfil </button> -->
    <!-- novo mini banner -->



    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>


</div>